module.exports = "./bd0a9338da2845255f0b9b6f87b5e1c0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@sabre/aven-spark/icons/build/fonts/spark-icon-line.svg
// module id = 1409
// module chunks = 0